import { useEffect, useRef, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from '@/components/Text';
import theme from '@/config/theme';

const styles = StyleSheet.create({
  visible: { color: theme.colors.black },
  hidden: { color: theme.colors.hiddenText },
  backgroundWhite: { backgroundColor: 'white' },
  backgroundGreen: { backgroundColor: theme.colors.primaryBrighter },
  fontGreen: { color: theme.colors.primary },
});

type HiddenTextProps = {
  visible?: boolean;
  greenBackground?: boolean;
  timeout?: number;
  style?: any;
  text?: string;
  isColored?: boolean | null;
};

const HiddenText = ({
  visible = false,
  greenBackground = true,
  timeout = 500,
  style = [],
  text,
  isColored,
}: HiddenTextProps) => {
  const [currentStyle, setCurrentStyle] = useState([
    visible ? styles.visible : styles.hidden,
    styles.backgroundWhite,
    ...style,
  ]);

  const refText = useRef(null);

  useEffect(() => {
    let timerHandle: null | ReturnType<typeof setTimeout>;
    if (visible) {
      if (greenBackground) {
        setCurrentStyle([
          styles.visible,
          isColored && styles.backgroundGreen,
          ...style,
        ]);
      } else {
        setCurrentStyle([isColored && styles.fontGreen, ...style]);
      }

      timerHandle = setTimeout(() => {
        setCurrentStyle([styles.visible, styles.backgroundWhite, ...style]);
      }, timeout);
    }

    return () => {
      if (timerHandle) {
        clearTimeout(timerHandle);
      }
    };
  }, [visible, greenBackground, timeout, style, isColored]);

  return (
    <Text
      selectionColor={'white'}
      style={[currentStyle, { userSelect: 'none' }]}
      ref={refText}
    >
      {text}
    </Text>
  );
};

export default HiddenText;
